import { render, staticRenderFns } from "./_base-custom-data-table.vue?vue&type=template&id=1a885246&scoped=true&"
import script from "./_base-custom-data-table.vue?vue&type=script&lang=js&"
export * from "./_base-custom-data-table.vue?vue&type=script&lang=js&"
import style0 from "./_base-custom-data-table.vue?vue&type=style&index=0&id=1a885246&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a885246",
  null
  
)

export default component.exports